import React, { PropTypes } from 'react'
import styled from 'styled-components'
import { translate } from 'react-i18next'
import Modal from '../../../components/Modal'
import Button from '../../../components/Button'
import CheckboxDropdown from '../../../components/CheckboxDropdown'
import SearchableDropdown from '../../../components/SearchableDropdown'
import RangePicker from '../../../components/RangePicker'
import {
  maxPrice,
  maxRooms,
  maxYield,
  maxArea,
  defaultPriceStep,
  defaultYieldStep,
  defaultRoomsStep,
  defaultAreaStep
} from '../../../Utils/Constants'
import { Metrics, Fonts, Colors } from '../../../Themes'

const FormTitle = styled.div`
  margin-bottom: ${Metrics.margins.small};
  ${Fonts.style.Label};
  color: ${Colors.primary};
`

const Form = styled.div`
  margin-bottom: ${Metrics.margins.base};

  .picker {
    .title {
      color: ${Colors.primary};
    }
  }
`

const CustomButton = styled(Button)`
  margin-top: ${Metrics.margins.large};
`

const Settings = props => {
  const {
    searches,
    handleRange,
    handleSelect,
    handleSelectAll,
    handleSearch,
    profile,
    t,
    next,
    router
  } = props
  return (
    <Modal
      visible
      closeAction={() => props.router.push('/landing')}
      header={<div className={'header'}>{t('Investor Profile')}</div>}
      backAction={router.goBack}>
      <Form>
        <FormTitle>
          {t('Please indicate the types of properties you are interested in')}
        </FormTitle>
        <CheckboxDropdown
          showSelectAll
          showCheckBox
          key='property'
          id='property'
          showTags
          width={'100%'}
          placeholder={t('Types of assets')}
          options={searches.categories}
          selectedOptions={profile.preferredCategories}
          handleSelect={el => handleSelect('preferredCategories', el)}
          handleSelectAll={list => handleSelectAll('preferredCategories', list)}
        />
      </Form>
      <Form>
        <FormTitle>{t('Continent')}</FormTitle>
        <SearchableDropdown
          key='continents'
          id='continents'
          showTags
          value={searches.continentSearch}
          placeholder={t('Specify the continents you wish to focus on')}
          options={searches.continents}
          selectedOptions={profile.preferredRegions}
          handleSearch={event => handleSearch(event, 'preferredRegions')}
          handleSelect={el => handleSelect('preferredRegions', el)}
          accessor={d => d.name}
          tagsAccessor={d => d.name}
        />
      </Form>
      <Form>
        <FormTitle>{t('Country')}</FormTitle>
        <SearchableDropdown
          key='countries'
          id='countries'
          showTags
          value={searches.countrySearch}
          placeholder={t('Specify the countries you wish to focus on')}
          options={searches.countries}
          selectedOptions={profile.preferredCountries}
          handleSearch={event => handleSearch(event, 'preferredCountries')}
          handleSelect={el => handleSelect('preferredCountries', el)}
          accessor={d => d.name}
          tagsAccessor={d => d.name}
        />
      </Form>
      <Form>
        <FormTitle>{t('City')}</FormTitle>
        <SearchableDropdown
          key='cities'
          id='cities'
          showTags
          value={searches.citySearch}
          placeholder={t('Specify the cities you wish to focus on')}
          options={searches.cities}
          selectedOptions={profile.preferredCities}
          handleSearch={event => handleSearch(event, 'preferredCities')}
          handleSelect={el => handleSelect('preferredCities', el)}
          accessor={d => `${d.city}, ${d.country.name}`}
          tagsAccessor={d => d.city}
        />
      </Form>
      <Form>
        <RangePicker
          key='keys'
          title={t('Size of the desired object (keys/rooms)')}
          minValue={profile.minNoRooms}
          maxValue={profile.maxNoRooms}
          step={defaultRoomsStep}
          max={maxRooms}
          handleChange={value => handleRange('minNoRooms', 'maxNoRooms', value)}
          className='rangeForm'
        />
      </Form>
      <Form>
        <RangePicker
          key='investment'
          title={t('Price range')}
          minValue={profile.minInvestment}
          maxValue={profile.maxInvestment}
          max={maxPrice}
          step={defaultPriceStep}
          unit={'€'}
          handleChange={value =>
            handleRange('minInvestment', 'maxInvestment', value)}
          className='rangeForm'
        />
      </Form>
      <Form>
        <RangePicker
          key='yield'
          minValue={profile.minYield}
          maxValue={profile.maxYield}
          title={t('Target yield')}
          max={maxYield}
          step={defaultYieldStep}
          unit={'%'}
          rightUnit
          handleChange={value => handleRange('minYield', 'maxYield', value)}
          className='rangeForm'
        />
      </Form>
      <Form>
        <RangePicker
          key='yield'
          minValue={profile.minArea}
          maxValue={profile.maxArea}
          title={t('Area')}
          max={maxArea}
          step={defaultAreaStep}
          unit={'m2'}
          rightUnit
          handleChange={value => handleRange('minArea', 'maxArea', value)}
          className='rangeForm'
        />
      </Form>
      <CustomButton
        label={'Next'}
        onClick={() => next('/landing/signup/more-settings')}
      />
    </Modal>
  )
}

Settings.propTypes = {
  handleRange: PropTypes.func.isRequired,
  handleSelect: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  searches: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  next: PropTypes.func.isRequired,
  t: PropTypes.func,
  router: PropTypes.object
}

export default translate([ 'common', 'landing', 'forms' ], { wait: true })(
  Settings
)



// WEBPACK FOOTER //
// ./src/pages/Landing/Onboarding/Settings.js